import LabelChip from './LabelChip';

export default LabelChip;
